import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestJsonPayload } from 'src/app/models/building.model';

@Injectable({
    providedIn: 'root'
})
export class CaseTypeService {

    caseTypesSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    caseTypes$: Observable<any> = this.caseTypesSubject.asObservable();

    baseUrlJsonpayloads = environment.baseUrlJsonpayloads;
    baseIncidentsAPI = environment.baseIncidentsAPI;
    userVerificationAPI = environment.baseUrlParties;
    casesAPI = environment.casesAPI;

    transactionIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    transactionId$: Observable<string> = this.transactionIdSubject.asObservable();
    transactionId: string;

    constructor(
        private http: HttpClient
    ) {

    }

    getCaseTypes() {
        return this.http.get(this.casesAPI);
    }

    validateUser(oktaPassword: string): Observable<any> {
      const request = {
        password: oktaPassword,
      };
      return this.http.post(this.userVerificationAPI + '/me/verify', request);
    }

    getCaseTypePayload(incidentId) {
      return this.http.get(`${this.baseIncidentsAPI}/${incidentId}`);
    }

    updateCaseTypePayload(incidentId, requestParam) {
      return this.http.put(`${this.baseIncidentsAPI}/${incidentId}`, requestParam);
    }

    postPayLoad(requestParam: any) {
      return this.http.post(`${this.baseIncidentsAPI}`, requestParam);
    }

    getJsonPayloads(transactionId) {
      return this.http.get(`${this.baseUrlJsonpayloads}/jsonpayloads/${transactionId}`);
    }

    postJsonPayloads(requestParam: RequestJsonPayload) {
      return this.http.post(this.baseUrlJsonpayloads + '/jsonpayloads', requestParam);
  }
}
